import { useFormik } from 'formik';
import React, { useState } from 'react';
import { Col, Modal, ModalBody, Row } from 'reactstrap';
import { userStatusUpdateReq } from '../../service/usersService';
import StyledButton from './StyledButton';

const DeactivateUserModal = (props) => {
  const {
    userData = {},
    userId,
    openModal,
    setOpenModal,
    notify,
  } = props;
  const [isButtonLoading, setIsButtonLoading] = useState(false);

  const safeUserData = {
    _id: userData?._id || userId || '',
    status: userData?.status || '',
    firstName: userData?.firstName || '',
    lastName: userData?.lastName || '',
  };

  const handleStatusUpdate = async () => {
    try {
      setIsButtonLoading(true);
      let response;
      response = await userStatusUpdateReq({
        userId: safeUserData._id,
        status: 'inactive',
      });

      if (response.success) {
        notify('Success', `User deactivated successfully`);
        setOpenModal(false);
      } else {
        throw new Error(response.message || 'Failed to update user status');
      }
    } catch (error) {
      console.error('Status update error:', error);
      notify('Error', error.response?.data?.message || error.message);
    } finally {
      setIsButtonLoading(false);
    }
  };

  const formik = useFormik({
    initialValues: {},
    onSubmit: async () => {
      await handleStatusUpdate('inactive');
    },
  });

  return (
    <Modal
      size="md"
      centered
      isOpen={openModal}
      toggle={() => {
        setOpenModal(false);
        formik.resetForm();
      }}
    >
      <form onSubmit={formik.handleSubmit}>
        <div className="modal-header">
          <div className="d-flex justify-content-between align-items-center w-100">
            <h4 className="card-title">Deactivate User</h4>
            <hr />
            <div className="d-flex gap-1">
              <StyledButton
                type="button"
                outline
                color="danger"
                className="waves-effect waves-light"
                onClick={() => {
                  formik.resetForm();
                  setOpenModal(false);
                }}
              >
                Cancel
              </StyledButton>
              <StyledButton
                type="submit"
                color="primary"
                isLoading={isButtonLoading}
                disabled={isButtonLoading}
              >
                Confirm
              </StyledButton>
            </div>
          </div>
        </div>
        <ModalBody>
          <Row>
            <Col className="mb-3">
              <>
                <p>
                  Deactivating{' '}
                  <strong>
                    {safeUserData.firstName} {safeUserData.lastName}
                  </strong>{' '}
                  will:
                </p>
                <ul>
                  <li>Block all logins immediately</li>
                  <li>Preserve their data for audit purposes</li>
                </ul>
              </>
            </Col>
          </Row>
        </ModalBody>
      </form>
    </Modal>
  );
};

export default DeactivateUserModal;
